<div [ngClass]="['tab-bar pb-4', 'tab-bar-' + size, customClass]" [class.full-width]="fullWidth">
  <ng-container *ngFor="let tab of tabs">
    <ng-container *ngTemplateOutlet="tab.templateButton"></ng-container>
  </ng-container>
</div>

<div *ngIf="activeTab?.content" [@contentAnimation]="selectedIndex">
  <ng-container *ngTemplateOutlet="activeTab.content"></ng-container>
</div>
